import { render, staticRenderFns } from "./ProductFormulaForm.vue?vue&type=template&id=578ec530&scoped=true&"
import script from "./ProductFormulaForm.vue?vue&type=script&lang=js&"
export * from "./ProductFormulaForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductFormulaForm.vue?vue&type=style&index=0&id=578ec530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578ec530",
  null
  
)

export default component.exports